import React, { useContext } from 'react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

const TABS = [
  { id: 'statistics',     label: 'Statistics' },
  { id: 'manage-profile', label: 'Manage Profile' },
];

export default function ProfileTabBar({ active = 'manage-profile', onTabChange }) {
  const theme = useContext(ThemeContext);
  return (
    <div style={{ display: 'flex', paddingLeft: s(32), paddingRight: s(32), flexShrink: 0 }}>
      {TABS.map(({ id, label }) => {
        const isActive = id === active;
        return (
          <button
            key={id}
            onClick={() => onTabChange && onTabChange(id)}
            className="font-satoshi font-bold"
            style={{
              flex: 1,
              padding: `${s(16)}px ${s(10)}px`,
              background: 'none',
              border: 'none',
              borderBottom: `3px solid ${isActive ? theme.btnPrimaryBg : theme.inputBorder}`,
              color: isActive ? theme.btnPrimaryBg : theme.text400,
              fontSize: s(18),
              lineHeight: `${s(24)}px`,
              cursor: 'pointer',
              textAlign: 'center',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
